import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Addwallet, getdisputemessages, getdisputerepliesmessages } from '../../Apis/index';

export const Wallet = createAsyncThunk('wallet', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await Addwallet({ formData, token });
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


const walletSlice = createSlice({
    name: 'wallet',
    initialState: {
        error: null,
        success: false,
        data: [],

    },
    reducers: {
        clearwallet: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(Wallet.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(Wallet.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(Wallet.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })



        // add 








    },

});
export const { clearwallet } = walletSlice.actions;
export default walletSlice.reducer;

